import script from "./company-updates-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./company-updates-list.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__